import { useEffect } from 'react'
import { useGetSetting } from 'api/settings'

// Syncs portal.title / portal.description / favicon into the document <title>, meta description and icon.
export const useDocumentMeta = () => {
  const { title, description, setting } = useGetSetting()
  const favicon = setting?.favicon?.full

  useEffect(() => {
    if (title) {
      document.title = title
    }
    if (description) {
      document.querySelector('meta[name="description"]')?.setAttribute('content', description)
    }
    if (favicon) {
      let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']")
      if (!link) {
        link = document.createElement('link')
        link.rel = 'icon'
        document.head.appendChild(link)
      }
      link.href = favicon
    }
  }, [title, description, favicon])
}
